import { Grid } from "@mui/material";
import { useMemo } from "react";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import {
  SESSION_INFO_FIELDS,
  SESSION_INFO_FIELD_LABEL,
  SESSION_NOTE_DATE_FORMAT,
} from "../group-visit-constant";
import { SessionDocumentationHeader } from "../group-visit-types";
import { toSessionInfoValues } from "../group-visit-utils";

export type SessionInformationFieldsProps = {
  header: SessionDocumentationHeader;
};

/**
 * Group name, session title, group type, providers and date & time of the
 * session being documented — read from the session, not typed.
 *
 * @author Rajkumar Rathod
 */
const SessionInformationFields = ({
  header,
}: SessionInformationFieldsProps) => {
  const values = useMemo(
    () => toSessionInfoValues(header, SESSION_NOTE_DATE_FORMAT),
    [header]
  );

  return (
    <Grid container spacing={2}>
      {SESSION_INFO_FIELDS.map((field) => (
        <Grid
          key={field}
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Flex flexDirection="column" gap={0.5}>
            <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
              {SESSION_INFO_FIELD_LABEL[field]}
            </Text>
            <Text {...CHART_TYPOGRAPHY.body4} c={CHART_COLORS.textDarker}>
              {values[field]}
            </Text>
          </Flex>
        </Grid>
      ))}
    </Grid>
  );
};

export default SessionInformationFields;
